import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import Card from "react-bootstrap/Card";
import ListGroup from "react-bootstrap/ListGroup";
import Merimg from "./Assestsimages/image.webp";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import "./Mergevv.css";
import maal_logo from "../../Images/maal_logo.png";
import {
  BsFillShareFill,
  BsThreeDots,
  BsEye,
  BsFillTagFill,
  BsStars,
} from "react-icons/bs";
import {
  AiFillThunderbolt,
  AiOutlineApartment,
  AiOutlineHeart,
  AiOutlineShoppingCart,
} from "react-icons/ai";
import { BiLinkExternal, BiTransfer } from "react-icons/bi";
import { SlGraph } from "react-icons/sl";
import maal_white_logo from "../../Images/maal_icon_white.png";
import { TfiMenuAlt } from "react-icons/tfi";
import { CiShare1 } from "react-icons/ci";
import logo_nft from "../../Images/logo_nft.jpg";
import Modal from "react-bootstrap/Modal";
import Accordion from "react-bootstrap/Accordion";
import { RxCross1 } from "react-icons/rx";
import Cardimd from "./Assestsimages/image.webp";
import Svgimg from "./Assestsimages/empty-asks.svg";
import Button from "react-bootstrap/Button";
import { ImSortAmountDesc, ImStatsBars2 } from "react-icons/im";
import { CgArrowsMergeAltH } from "react-icons/cg";
import { TbListDetails } from "react-icons/tb";
import { BsTwitter, BsFillCollectionFill } from "react-icons/bs";
import { FaEthereum } from "react-icons/fa";
import ProgressBar from "react-bootstrap/ProgressBar";
import Mergeimg from "./Assestsimages/merge.svg";
import { RiArrowUpDownFill } from "react-icons/ri";
import Dropdown from "react-bootstrap/Dropdown";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import DropdownButton from "react-bootstrap/DropdownButton";
import Mergecards from "./Mergecards";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import CardMedia from "@material-ui/core/CardMedia";
import {
  get_Marketplace_contract,
  get_Minting_contract_1155,
  get_Minting_contract_721,
  ensureAllowance,
  ensureNftApproval,
  get_all_nft_contract_,
  get_ERC20_contract,
  mintedTokenIds,
} from "../../Web3/Contract";
import {
  convertToLowercase,
  multiplyWei,
  rpcURL,
  userBalanceOfChain,
  utils_fromowei,
  utils_towei,
} from "../../Web3/web3_api";
import { MAINNETTOKENS, TOKENS } from "../../Web3/ABI";
import { errorMessage } from "../../Web3/errors";
import { getValidatorData, isValidatorLocked, isValidatorNft, withValidatorData } from "../../Web3/validator";
import Web3 from "web3";

import toast, { Toaster } from "react-hot-toast";
import Footer from "../Footer";
import moment from "moment";
import { IoIosArrowDown } from "react-icons/io";
import Navbarnft_global from "../Navbars/Navbarnft_global";
import { DatePicker } from "antd";

const notify = (msg) => toast.success(msg);
const warning = (msg) => toast.error(msg);

const NATIVE = "0x0000000000000000000000000000000000000000";
const PAGE = 50;

/** Every ID from a paginated marketplace view, which has no count getter. */
const pageAll = async (fetchPage) => {
  const all = [];
  for (let offset = 0; ; offset += PAGE) {
    const page = await fetchPage(offset, PAGE);
    all.push(...page);
    if (page.length < PAGE) return all;
  }
};

const tokenSymbol = (currency) => {
  const token = MAINNETTOKENS.find((item) => item.address.toLowerCase() === String(currency).toLowerCase());
  return token ? token.symbol : "";
};

/** The v2 contracts take expiry in unix seconds; the date pickers give milliseconds. */
const toSeconds = (millis) => Math.floor(Number(millis) / 1000);

export default function Mergevv({ URL, UserWallet, signMessage, logout }) {
  const [open1, setOpen1] = React.useState(true);

  const handleToggle = () => {
    setOpen(!open);
  };

  const { id } = useParams();

  const [owner, setOwner] = useState();
  const [tokenID, setToeknID] = useState();
  const [imageURL, setImageURL] = useState(``);
  const [tokenAddress, setTokenAddress] = useState();
  const [attribute, setAttribute] = useState([]);
  const [receiveraddress, setReceiverAddresss] = useState();
  const [description, setDescription] = useState();
  const [time, setTime] = useState();
  const [type, setType] = useState();
  const [collection, setCollection] = useState();
  const [collectionMongoId, setCollectionMongoId] = useState();
  const [name, setName] = useState();
  const [show4, setShow4] = useState(false);
  const [show5, setShow5] = useState(false);
  const [show_minting, setShow_minting] = useState(false);
  const [show6, setShow6] = useState(false);
  const [show7, setShow7] = useState(false);
  const [show8, setShow8] = useState(false);
  const [price, setPrice] = useState(0);
  const [open, setOpen] = React.useState(false);
  const [percent, setPercent] = React.useState(0);
  const [offeramount, setOfferamount] = useState(0);
  const [isListed, setIsListed] = useState(false);
  const [listedprice, setListedprice] = useState(0);
  const [nftofsamecollection, setNFTofSameCollection] = useState();
  const [nfttransaction, setNFTTransaction] = useState();
  const [creatorName, setCreatorName] = useState();
  const [creatoraddress, setCreatorAddress] = useState();
  const [lastupdate, setLastUpdate] = useState();
  const [royalty_address, setRoyalty_address] = useState();
  const [Collection_id, setCollection_ID] = useState();
  const [quantityToSale, setQuantityToSale] = useState();
  const [pricePerNFT, setPricePerNFT] = useState();
  const [expireTime, setExpireTime] = useState();
  const [quantitytopuchase, setQuantityToPurchase] = useState();
  const [offerexpire, setOfferExpire] = useState();
  const [listingId, setListingID] = useState();
  const [quantityonsale, setQuantityonSale] = useState();
  const [quantityTopuchaseDirect, setQuantityToPurchaseDirect] = useState();
  const [balance_1155, setBalance_1155] = useState();
  const [seller, setSeller] = useState();
  const [isMusicalNFT, setIsMusicalNFT] = useState(false);
  const [musical_nft_data, setMusical_nft_data] = useState([]);
  const [nft, setNFT] = useState();
  const [totalMinted, setTotalMinted] = useState();
  const [totalSupple, setTotalSupply] = useState();
  const [listingTokenSymbol, setListingTokenSymbol] = useState();
  const [listingTokenBalance, setListingTokenBalance] = useState(0);
  const [listingTokenAddress, setListingTokenAddress] = useState("");
  const [maalprice, setMaalPrice] = useState(0)
  const [offerID, setOfferID] = useState();
  const [newprice, setNewPrice] = useState();
  const [newTime, setNewTime] = useState();
  const [tokenForSale, setTokenForSale] = useState(NATIVE);
  const [royaltyFee, setRoyaltyFee] = useState();
  const [custom, setCustom] = useState();
  // Validator NFTs are not traded on PanSea; transfers revert while locked.
  const [validator, setValidator] = useState(false);
  const [validatorLockedTill, setValidatorLockedTill] = useState();
  const [airdrop, setAirdrop] = useState();
  const [collection_name, setCollectionName] = useState();
  const [transferaddress, setTransferaddress] = useState();
  const [transferID, setTransferID] = useState();
  const [receiveXaus, setReceiveXaus] = useState(0);
  const [transferamount, setTransferAmount] = useState();
  const [isVideo, setIsVideo] = useState();
  const handleClose4 = () => setShow4(false);
  const handleShow4 = () => setShow4(true);

  const handleClose5 = () => setShow5(false);
  const handleShow5 = () => setShow5(true);
  const handleClose_minting = () => setShow_minting(false);
  const handleShow_minting = () => setShow_minting(true);

  const handleClose6 = () => setShow6(false);
  const handleShow6 = () => setShow6(true);
  const handleShow7 = () => setShow7(!show7);
  const handleClose8 = () => setShow8(false);
  const handleShow8 = () => setShow8(true);

  useEffect(() => {
    axios
      .get(`${URL}/nftsinglebyid/${id}`)
      .then(async (res) => {
      
        setNFT(res.data);
        setTime(res.data.CreatedAt);
        setName(res.data.name);
        setCollectionMongoId(res.data._id);
        setCreatorAddress(res.data.Creator);
        setTokenAddress(res.data.NFTContract);
        setImageURL(res.data.imageURL);
        setToeknID(res.data.tokenID);
        setOwner(res.data.Owner);
        setCollection(res.data.collectionID);
        setLastUpdate(res.data.last_update);
        setType(res.data.nftType);
        setTotalMinted(res.data.totalMinted);
        setTotalSupply(res.data.supply);
        setAttribute(res.data.attributes);
        setTotalSupply(res.data.supply);
        setDescription(res.data.description);
        setCustom(res.data.isCustom);
        const validatorNft = isValidatorNft(res.data.NFTContract);
        setValidator(validatorNft);
        setAirdrop(res.data.airDropNFT);
        goldprice();
        MaalPrice();
        // fetching creator name by its wallet address
        axios
          .post(`${URL}/getuser`, {
            wallet: res.data.Creator,
          })
          .then((res) => {
            setCreatorName(res.data[0].name);
          });

        axios
          .post(`${URL}/collectionbyname`, {
            name: res.data.collectionID,
          })
          .then((res) => {
            setRoyalty_address(res.data.royalty_address);
            setRoyaltyFee(res.data.fee);
            setCollectionName(res.data.name);
          });

        if (res.data.isCustom) {
          const contractValidator = await get_all_nft_contract_(
            res.data.NFTContract
          );
          const uri = await contractValidator.methods.baseURI().call();
          const nftname = await contractValidator.methods.name().call();
          const nftowner = await contractValidator.methods
            .ownerOf(res.data.tokenID)
            .call();
          setOwner(convertToLowercase(nftowner));
          const Datafromserver = await axios
            .post(`${URL}/callcorsapi`, {
              uri: `${uri}${res.data.tokenID}.json`,
            })
            .then((res) => {
              return res.data;
            });

          const validatorData = validatorNft ? await getValidatorData(res.data.tokenID) : null;
          setValidatorLockedTill(isValidatorLocked(validatorData) ? validatorData.lockedTill : undefined);

          if (Datafromserver != "") {
            setName(nftname);
            setAttribute(withValidatorData(Datafromserver.attributes, validatorData));
            setImageURL(
              Datafromserver.animation_url
                ? Datafromserver.animation_url
                : Datafromserver.image
            );
            setIsVideo(Datafromserver.animation_url ? true : false);
            setDescription(Datafromserver.description);
          }
        } else if (res.data.airDropNFT) {
        
          const contractValidator = await get_all_nft_contract_(
            res.data.NFTContract
          );
          // tokenURI is right for AirDrop v1 and for v2 drops, revealed or not.
          const tokenUri = await contractValidator.methods.tokenURI(res.data.tokenID).call();

          const nftname = await contractValidator.methods.name().call();

          const nftowner = await contractValidator.methods
            .ownerOf(res.data.tokenID)
            .call();

          setOwner(convertToLowercase(nftowner));

          const Datafromserver = await axios
            .post(`${URL}/callcorsapi`, {
              uri: tokenUri,
            })
            .then((res) => {
              return res.data;
            });

          if (Datafromserver != "") {
            setName(nftname);
            setAttribute(Datafromserver.attributes);
            setImageURL(
              Datafromserver.animation_url
                ? Datafromserver.animation_url
                : Datafromserver.image
                ? Datafromserver.image
                : logo_nft
            );
            setIsVideo(Datafromserver.animation_url ? true : false);
            setDescription(Datafromserver.description);
          }
        } else {
          const contractValidator = await get_Minting_contract_1155(
            res.data.NFTContract
          );
          // const nftowner = await contractValidator.methods.owner().call();
          const balance = await contractValidator.methods
            .balanceOf(UserWallet, res.data.tokenID)
            .call();
          setBalance_1155(balance);
          setOwner("1155");
        }
      })
      .catch((error) => {
        console.log("Error", error);
      });

    axios
      .post(`${URL}/gettrx/${id}`)
      .then((res) => {
        setNFTTransaction(res.data);
      })
      .catch(console.error);
  }, [UserWallet, open, id]);

 

  const slice = (str) => {
    if (str) {
      const first = str.slice(0, 5);
      const second = str.slice(38);
      return first + "..." + second;
    }
  };

  const [alloffers, setAllOffers] = useState([]);

  useEffect(() => {
    const init = async () => {
      try {
        if (!tokenAddress || tokenID === undefined) return;
        const marketplace = await get_Marketplace_contract();

        // The v2 marketplace keeps one live listing per ERC721 token; ERC1155
        // tokens can have several, so take the newest one that can be bought.
        let listingID = "0";
        if (type === 721) {
          listingID = await marketplace.methods.activeERC721Listing(tokenAddress, tokenID).call();
        } else {
          const ids = await pageAll((offset, limit) =>
            marketplace.methods.listingsByToken(tokenAddress, tokenID, offset, limit).call()
          );
          for (const candidate of ids.reverse()) {
            if (await marketplace.methods.isListingValid(candidate).call()) {
              listingID = candidate;
              break;
            }
          }
        }
        const isValid = listingID !== "0" && (await marketplace.methods.isListingValid(listingID).call());
        setListingID(listingID);
        setIsListed(isValid);

        if (isValid) {
          const listing = await marketplace.methods.getListing(listingID).call();
          setSeller(convertToLowercase(listing.seller));
          setQuantityonSale(Number(listing.quantity));
          setListedprice(Number(await utils_fromowei(listing.pricePerUnit)));
          setPricePerNFT(listing.pricePerUnit);

          if (listing.currency === NATIVE) {
            setListingTokenSymbol("MAAL");
            const NativeBalance = await userBalanceOfChain(UserWallet);
            setListingTokenBalance(NativeBalance);
            setListingTokenAddress(listing.currency);
          } else {
            const tokenContract = await get_ERC20_contract(listing.currency);
            const name = await tokenContract.methods.symbol().call();

            const tokenbalance = await tokenContract.methods
              .balanceOf(UserWallet)
              .call();
            const towio = await utils_fromowei(tokenbalance);
            setListingTokenBalance(towio);
            setListingTokenSymbol(name);
            setListingTokenAddress(listing.currency);
          }
        } else {
          setListingTokenAddress(NATIVE);
          setListingTokenSymbol("MAAL");
        }

        // v2 offers are made on the token, not on a listing, so they show whether or not it is listed.
        const offerIds = await pageAll((offset, limit) =>
          marketplace.methods.offersByToken(tokenAddress, tokenID, offset, limit).call()
        );
        const now = new Date().getTime() / 1000;
        const get_Offers = [];
        for (const offerId of offerIds) {
          const offer = await marketplace.methods.getOffer(offerId).call();
          if (offer.status === "1" && Number(offer.expiry) > now) {
            // The legacy field names the offer list renders.
            get_Offers.push({
              offerId: offerId,
              offerCreator: offer.bidder,
              pricePerNFT: offer.pricePerUnit,
              offerExpireTime: offer.expiry,
              quantity: offer.quantity,
              currency: offer.currency,
              symbol: tokenSymbol(offer.currency),
            });
          }
        }
        setAllOffers(get_Offers);
      } catch (error) {
        // console.log(error);
      }
    };
    init();
  }, [tokenAddress, tokenID, type, UserWallet, open, id, Collection_id]);

  const goldprice = async () => {
    const xau = await axios
      .get("https://www.goldapi.io/api/XAU/USD", {
        headers: {
          "x-access-token": "goldapi-3etxdtl90ttr5o-io",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setReceiveXaus((res.data.price * 0.425) / 31.1034768);
      })
      .catch(console.error);
    return xau;
  };

  const sellNFT = async () => {
    try {
      setOpen(true);
      const marketplace = await get_Marketplace_contract();
      if (!price || !expireTime) {
        warning("Enter a price and an expiry date");
        setOpen(false);
        return;
      }
      if (type !== 721 && Number(quantityToSale) > Number(balance_1155)) {
        warning("Insufficient balance");
        setOpen(false);
        return;
      }
      // One approval per collection lets the marketplace move the NFT when it sells;
      // the NFT stays in the seller's wallet until then.
      const nft =
        type === 721
          ? await get_Minting_contract_721(tokenAddress)
          : await get_Minting_contract_1155(tokenAddress);
      await ensureNftApproval(UserWallet, nft);
      setPercent(50);

      const data = await marketplace.methods
        .listNFT(
          tokenAddress,
          tokenID,
          type === 721 ? 1 : quantityToSale,
          tokenForSale,
          price,
          toSeconds(expireTime)
        )
        .send({ from: UserWallet });
      if (data.status) {
        setPercent(100);
        setOpen(false);
        notify("Success");
      } else {
        setOpen(false);
        setPercent(0);
      }
    } catch (error) {
      setOpen(false);
      setPercent(0);
      warning(errorMessage(error));
      console.log(error);
    }
  };

  const handlePrice = async (value) => {
    const number = await utils_towei(value);
    setPrice(number);
  };

  const updateOffer = async (newprice, newTime) => {
    try {
      setOpen(true);
      const number = await utils_towei(newprice);
      const time = Number(new Date(newTime).getTime() / 1000).toFixed(0);
      const marketplace = await get_Marketplace_contract();
      // Raising the price collects the difference; lowering it refunds it.
      const offer = await marketplace.methods.getOffer(offerID).call();
      const oldTotal = multiplyWei(offer.pricePerUnit, offer.quantity);
      const newTotal = multiplyWei(number, offer.quantity);
      const extra = Web3.utils.toBN(newTotal).sub(Web3.utils.toBN(oldTotal));
      let value = "0";
      if (extra.gtn(0)) {
        if (offer.currency === NATIVE) {
          value = extra.toString();
        } else {
          await ensureAllowance(UserWallet, offer.currency, extra.toString());
        }
      }
      const data = await marketplace.methods
        .modifyOffer(offerID, number, time)
        .send({ from: UserWallet, value: value });
      if (data.status) {
        setOpen(false);
        notify("Success");
      }
    } catch (error) {
      console.log(error);
      warning(errorMessage(error));
      setOpen(false);
    }
  };

  const MaalPrice = () => {
    axios
      .get("https://api.coingecko.com/api/v3/simple/price?ids=maal-chain&vs_currencies=usd")
      .then((res) => {
        setMaalPrice(res.data["maal-chain"].usd)
        
      })
      .catch((err) => {
        console.log(err)
      });
  };

  const update_owner = async (Offerer, price, hash, rpc, buyingFrom) => {
    axios
      .post(`${URL}/purhchased/${id}`, {
        Owner: Offerer,
        price: price,
        collectionID: collection,
        last_update: new Date().getTime(),
        hash: hash,
        rpc: rpc,
        buyingFrom: buyingFrom,
      })
      .then((res) => {
        console.log(res);
      })
      .catch(console.error);
  };

  const update_owner_Of_transfer = async (receiver) => {
    try {
      axios
        .post(`${URL}/transfer/${id}`, {
          receiver: receiver,
        })
        .then((res) => {
          console.log(res);
          setOpen(false);
          handleClose8();
        })
        .catch(setOpen(false));
    } catch (error) {
      setOpen(false);
      handleClose8();
      console.log(error);
    }
  };

  const make_Offerr = async () => {
    try {
      setOpen(true);
      // Offers are made on the token; the funds are held by the marketplace until
      // the offer is accepted, cancelled or expires.
      const currency = listingTokenAddress || NATIVE;
      const quantity = type === 721 ? 1 : quantitytopuchase;
      const number = await utils_towei(offeramount);
      const total = multiplyWei(number, quantity);
      if (currency !== NATIVE) {
        await ensureAllowance(UserWallet, currency, total);
      }
      const marketplace = await get_Marketplace_contract();
      const data = await marketplace.methods
        .makeOffer(tokenAddress, tokenID, quantity, currency, number, toSeconds(offerexpire))
        .send({ from: UserWallet, value: currency === NATIVE ? total : "0" });
      if (data.status) {
        setOpen(false);
        notify("Success");
      } else {
        setOpen(false);
      }
    } catch (error) {
      console.log(error);
      warning(errorMessage(error));
      setOpen(false);
    }
  };

  const accept_offer = async (offerer, price, id, offerQuantity) => {
    try {
      setOpen(true);
      const rpc = rpcURL();
      const marketplace = await get_Marketplace_contract();
      // The holder accepts: the marketplace needs approval to move the NFT.
      const nft =
        type === 721
          ? await get_Minting_contract_721(tokenAddress)
          : await get_Minting_contract_1155(tokenAddress);
      await ensureNftApproval(UserWallet, nft);
      const quantity =
        type === 721 ? 1 : Math.min(Number(offerQuantity), Number(balance_1155));
      const data = await marketplace.methods
        .acceptOffer(id, quantity, price)
        .send({ from: UserWallet })
        .on("transactionHash", async function (hash) {
          const a = await utils_fromowei(price);
          update_owner(offerer, a, hash, rpc, UserWallet);
          await make_transaction("Sale", UserWallet, offerer, a, hash, rpc);
          await make_transaction("Buy", offerer, UserWallet, a, hash, rpc);
        });
      if (data.status) {
        setOpen(false);
        notify("Success");
      } else {
        setOpen(false);
      }
    } catch (error) {
      console.log(error);
      warning(errorMessage(error));
      setOpen(false);
    }
  };

  const buy_nft = async () => {
    try {
      setOpen(true);
      const rpc = rpcURL();
      const total = multiplyWei(pricePerNFT, quantityTopuchaseDirect);
      const isNative = listingTokenAddress === NATIVE;
      if (!isNative) {
        await ensureAllowance(UserWallet, listingTokenAddress, total);
      }
      const marketplace = await get_Marketplace_contract();
      // `pricePerNFT` is the price shown: the buy reverts (PriceMismatch) if the seller raised it.
      const data = await marketplace.methods
        .buyNFT(listingId, quantityTopuchaseDirect, pricePerNFT)
        .send({ from: UserWallet, value: isNative ? total : "0" })
        .on("transactionHash", async function (hash) {
          await update_owner(UserWallet, listedprice, hash, rpc, seller);
          await make_transaction(
            "Buy",
            seller,
            UserWallet,
            listedprice,
            hash,
            rpc,
            listingTokenSymbol
          );
          await make_transaction(
            "Sale",
            UserWallet,
            seller,
            listedprice,
            hash,
            rpc,
            listingTokenSymbol
          );
        });
      if (data.status) {
        setOpen(false);
        notify("Success");
      } else {
        setOpen(false);
      }
    } catch (error) {
      setOpen(false);
      warning(errorMessage(error));
    }
  };

  const CancalOffer = async (offerID) => {
    try {
      const marketplace = await get_Marketplace_contract();
      const data = await marketplace.methods
        .cancelOffer(offerID)
        .send({ from: UserWallet });
      if (data.status) {
        notify("Offer cancelled and refunded");
      }
    } catch (error) {
      warning(errorMessage(error));
    }
  };

  const make_transaction = async (
    event_Type,
    from,
    to,
    value,
    hash,
    rpc,
    symbol
  ) => {
    axios
      .post(`${URL}/maketrx`, {
        nft_id: id,
        event: event_Type,
        nftContract: tokenAddress,
        from: from,
        to: to,
        symbol: symbol,
        value: value,
        time: new Date().getTime(),
        hash: hash,
        rpc: rpc,
      })
      .then((res) => {
        console.log(res);
      })
      .catch(console.error);
  };

  const price_to_wei = async (amount) => {
    try {
      const number = await utils_fromowei(amount);
      return number;
    } catch (error) {}
  };

  const Time_ago = (time) => {
    const date = moment(time).fromNow();
    return date;
  };

  const Time_data = (time) => {
    const date = moment(time).format("L");
    return date;
  };

  const sliceAddresss = (address) => {
    const first = address.slice(0, 5);
    const second = address.slice(38);
    return first + "..." + second;
  };

  const sliceAdd = (address) => {
    if (typeof address === "string") {
      const first = address.slice(0, 7);
      return first + "...";
    } else {
      return "Invalid address";
    }
  };

  const mintAgain = async (data) => {
    try {
      delete nft._id;
      nft.Owner = receiveraddress;
      setOpen(true);
      const nftcontract = await get_Minting_contract_721(tokenAddress);
      // Another copy with the same metadata; the contract assigns the token ID and
      // enforces the supply cap.
      const uri = nft.metadata || (await nftcontract.methods.tokenURI(tokenID).call());
      const data1 = await nftcontract.methods
        .mint(receiveraddress, uri)
        .send({ from: UserWallet });
      const [newTokenID] = mintedTokenIds(data1);
      if (data1.status && newTokenID) {
        console.log(nft);
        nft.tokenID = newTokenID;
        nft.last_update = new Date().getTime();
        await axios
          .post(`${URL}/makenftsagain`, nft)
          .then((res) => {
            console.log(res.data);
            notify("NFT created successfully");
            setOpen(false);
          })
          .catch((error) => {
            console.log(error);
            setOpen(false);
          });
      } else {
        setOpen(false);
      }
    } catch (error) {
      console.log(error);
      warning(errorMessage(error));
      setOpen(false);
    }
  };

  const transferNFT = async () => {
    try {
      setOpen(true);
      if (type === 1155) {
        console.log("1155 Type");
        const nft = await get_Minting_contract_1155(tokenAddress);
        console.log("Contract", nft);
        const data = await nft.methods
          .safeTransferFrom(
            UserWallet,
            transferaddress,
            tokenID,
            transferamount,
            "0x98"
          )
          .send({ from: UserWallet });
        if (data.status) {
          update_owner_Of_transfer(transferaddress);
          setOpen(false);
          handleClose8();
        }
      } else {
        console.log("721 Type");
        const nft = await get_Minting_contract_721(tokenAddress);
        const data = await nft.methods
          .transferFrom(UserWallet, transferaddress, tokenID)
          .send({ from: UserWallet });
        if (data.status) {
          update_owner_Of_transfer(transferaddress);
          setOpen(false);
          handleClose8();
        }
      }
    } catch (error) {
      console.log(error);
      setOpen(false);
      handleClose8();
    }
  };

  const sliceNum = (num) => {
    if (!num) {
      return;
    }
    const fir = num.toString().slice(0, 5);
    return fir + "...";
  };

  const theme_mode = localStorage.getItem("theme");

  return (
    <>
      <Navbarnft_global
        UserWallet={UserWallet}
        signMessage={signMessage}
        logout={logout}
        URL={URL}
      />
      <Box className="container-kws ">
        <Grid container space={2} className="p-t-2">
          <Grid xl={5} lg={5} md={12} sm={12} xs={12}>
            <div>
              <div className="container-fluid">
                <div className="col-12  m-q-a-d-n">
                  <div className="d-f  j-c-s-b a-i-c">
                    <div className="">
                      <Link to={`/collection/${collection_name}/${collection}`}>
                        <span className="yellow_clr">{collection_name}</span>
                      </Link>
                    </div>
                    <div className="">
                      <div className="">
                        {" "}
                        {validator ? (
                          <Button
                            variant="primary"
                            className="sell-buttons"
                            id="button-sell-color"
                          >
                            {validatorLockedTill
                              ? `Locked until ${new Date(validatorLockedTill).toLocaleDateString()}`
                              : "Not for Sale"}
                          </Button>
                        ) : (owner === UserWallet && isListed) ||
                        seller == UserWallet ? (
                          <Button
                            variant="primary"
                            // onClick={handleShow4}
                            className="sell-buttons"
                            id="button-sell-color"
                          >
                            Listed for Sale
                          </Button>
                        ) : owner == UserWallet && !isListed ? (
                          <Button
                            variant="primary"
                            onClick={handleShow4}
                            className="sell-buttons"
                            id="button-sell-color"
                          >
                            List for Sale
                          </Button>
                        ) : owner === "1155" &&
                          !isListed &&
                          balance_1155 > 0 ? (
                          <Button
                            variant="primary"
                            onClick={handleShow4}
                            className="sell-buttons"
                            id="button-sell-color"
                          >
                            List for Sale
                          </Button>
                        ) : owner != UserWallet && isListed ? (
                          <Button
                            variant="primary"
                            onClick={handleShow5}
                            className="sell-buttons"
                            id="button-sell-color"
                          >
                            Make offer
                          </Button>
                        ) : (
                          <Button
                            variant="primary"
                            // onClick={handleShow5}
                            className="sell-buttons"
                            id="button-sell-color"
                          >
                            Not for Sale
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>{" "}
              <div className="p-x-0_5">
                {custom ? (
                  <article className="sc-57ceaf99-0 sc-2092e28b-0 kHrhvD bJqyHU item--frame item--media-frame m-b-3">
                    <div className="d-f a-i-c j-c-s-b pa-1">
                      {theme_mode == "light-theme" ? (
                        <img
                          src={maal_logo}
                          className="w-1_5 b-r-50"
                        />
                      ) : (
                        <img src={maal_white_logo} className="w-1_5 b-r-50" />
                      )}

                      <div className="d-f a-i-c">
                        <BiLinkExternal className="f-s-1_25" />
                        {/* &nbsp; 0 &nbsp;
                        <AiOutlineHeart className="f-s-1_25" /> */}
                      </div>
                    </div>

                    <div className="sc-57ceaf99-0 sc-ce8ac90b-0 kHrhvD iPiVBj">
                      <div className="sc-57ceaf99-0 inwolf">
                        <div
                          height="100%"
                          width="100%"
                          className="sc-57ceaf99-0 ikUvYq"
                        >
                          <div className="sc-fabf517e-0 hObjOE item--media">
                            <div
                              height="100%"
                              width="100%"
                              className="sc-57ceaf99-0 sc-630fc9ab-0 sc-99655001-0 sc-4422a702-0 sc-dada3b88-0 jLlAQq bNkKFC dsowZP jZNcco bhxycR"
                            >
                              <div className="AssetMedia--animation">
                                <div className="sc-57ceaf99-0 sc-630fc9ab-0 sc-99655001-0 sc-4422a702-0 sc-dada3b88-0 kHrhvD bNkKFC dsowZP jZNcco bhxycR AssetMedia--playback-wrapper">
                                  {imageURL ? (
                                    <>
                                      {isVideo ? (
                                        <video
                                          autoPlay
                                          className="AssetMedia--video"
                                          controls
                                          controlsList="nodownload"
                                          loop
                                          playsInline
                                          // poster="https://i.seadn.io/gcs/files/cd3480224f20f93f996bc1c63c07371b.jpg?w=500&amp;auto=format"
                                          preload="metadata"
                                          style={{
                                            objectFit: "contain",
                                            borderRadius: "initial",
                                          }}
                                        >
                                          <source
                                            data-testid="AssetMedia--video"
                                            src={imageURL}
                                            type="video/mp4"
                                          />
                                        </video>
                                      ) : (
                                        <Card.Img
                                          variant="top"
                                          src={imageURL}
                                          id="card-nft-main-image"
                                          className="b-r-10 "
                                        />
                                      )}
                                    </>
                                  ) : (
                                    <div className="p-y-5 t-a-c">
                                      Loading video...
                                    </div>
                                  )}
                                  <div></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </article>
                ) : airdrop ? (
                  <article className="sc-57ceaf99-0 sc-2092e28b-0 kHrhvD bJqyHU item--frame item--media-frame m-b-3">
                    <div className="d-f a-i-c j-c-s-b pa-1">
                      {theme_mode == "light-theme" ? (
                        <img
                          src={maal_logo}
                          className="w-1_5 b-r-50"
                        />
                      ) : (
                        <img src={maal_white_logo} className="w-1_5 b-r-50" />
                      )}
                      <div className="d-f a-i-c">
                        <BiLinkExternal className="f-s-1_25 c-p" />
                      </div>
                    </div>

                    {imageURL ? (
                      <>
                        {isVideo ? (
                          <video
                            autoPlay
                            className="AssetMedia--video"
                            controls
                            controlsList="nodownload"
                            loop
                            playsInline
                            // poster="https://i.seadn.io/gcs/files/cd3480224f20f93f996bc1c63c07371b.jpg?w=500&amp;auto=format"
                            preload="metadata"
                            style={{
                              objectFit: "contain",
                              borderRadius: "initial",
                            }}
                          >
                            <source
                              data-testid="AssetMedia--video"
                              src={imageURL}
                              type="video/mp4"
                            />
                          </video>
                        ) : (
                          <Card.Img
                            variant="top"
                            src={imageURL}
                            id="card-nft-main-image"
                            className="b-r-10 "
                          />
                        )}
                      </>
                    ) : (
                      <div className="p-y-5 t-a-c">Loading video...</div>
                    )}
                  </article>
                ) : (
                  <article className="sc-57ceaf99-0 sc-2092e28b-0 kHrhvD bJqyHU item--frame item--media-frame m-b-3">
                    <div className="d-f a-i-c j-c-s-b pa-1">
                      {theme_mode == "light-theme" ? (
                        <img
                          src={maal_logo}
                          className="w-1_5 b-r-50"
                        />
                      ) : (
                        <img src={maal_white_logo} className="w-1_5 b-r-50" />
                      )}

                      <div className="d-f a-i-c">
                        <BiLinkExternal className="f-s-1_25 c-p" />
                      </div>
                    </div>
                    {imageURL ? (
                      <>
                        {isVideo ? (
                          <video
                            autoPlay
                            className="AssetMedia--video"
                            controls
                            controlsList="nodownload"
                            loop
                            playsInline
                            // poster="https://i.seadn.io/gcs/files/cd3480224f20f93f996bc1c63c07371b.jpg?w=500&amp;auto=format"
                            preload="metadata"
                            style={{
                              objectFit: "contain",
                              borderRadius: "initial",
                            }}
                          >
                            <source
                              data-testid="AssetMedia--video"
                              src={imageURL}
                              type="video/mp4"
                            />
                          </video>
                        ) : (
                          <Card.Img
                            variant="top"
                            src={imageURL}
                            id="card-nft-main-image"
                            className="b-r-10 "
                          />
                        )}
                      </>
                    ) : (
                      <div className="p-y-5 t-a-c">Loading video...</div>
                    )}
                  </article>
                )}
              </div>
            </div>
            <div className="container-fluid">
              <div className="boxes">
                <div className="bbb">
                  <ImSortAmountDesc /> <span>Description</span>
                </div>
                <div className="des">
                  <span>
                    By <strong>{creatorName}</strong>
                  </span>
                  <br />
                  <span>{creatoraddress ? sliceAdd(creatoraddress) : ""}</span>
                </div>
                <hr id="hr2" />
                <div className="accordion ">
                  <Accordion>
                    <Accordion.Item eventKey="0" className="b-n">
                      <Accordion.Header className="b-n">
                        <BsFillTagFill className="price-gr " />
                        Properties
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="row">
                          {attribute &&
                            attribute.map((res) => {
                              return (
                                <div className="col-12 col-sm-6 col-md-6 col-xl-4 col-xxl-4 col-xxxl-3  p-x-0_25 m-y-0_25">
                                  <div>
                                    <div className="properties-box">
                                      <span className="properties-na yellow_clr f-s-0_8">
                                        {res.trait_type
                                          ? res.trait_type
                                          : res.type}
                                      </span>
                                      <div className="merg f-s-0_8">
                                        {res.value}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          {attribute && attribute.length > 0 ? (
                            ""
                          ) : (
                            <div className="p-y-3 t-a-c">
                              NO data to show...
                            </div>
                          )}
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
                {/* <div className="accordion">
                  <Accordion defaultActiveKey="0">
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        <ImStatsBars2 className="price-gr" />
                        Levels
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="value-item">
                          <span className="value">Number</span>
                          <div className="numbers-bar">
                            <span className="value">25,600 of 29,963</span>
                          </div>
                        </div>
                        <div>
                          <ProgressBar now={60} />
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div> */}
                <hr id="hr2" />
                <div className="accordion ">
                  <Accordion>
                    <Accordion.Item eventKey="0" className="b-n">
                      <Accordion.Header>
                        <CgArrowsMergeAltH className="price-gr" />
                        About
                      </Accordion.Header>
                      <Accordion.Body>
                        <div>
                          <div className="d-flex">
                            {/* <div className="h-18 ">
                              <video  autoPlay loop>
                                <source
                                  src={imageURL}
                                  type="video/mp4"
                                  className="h-18 "
                                />
                                Your browser
                              </video>
                              </div>
                            */}

                            <div className="merge-details p-l-0 m-l-0">
                              {description}
                            </div>
                          </div>
                          <div className="social-icon d-flex ">
                            <div className="twitter">
                              <BsTwitter />
                            </div>
                            {/* <div className="eth">
                              <FaEthereum />
                            </div> */}
                            <div className="dot">
                              <BsThreeDots />
                            </div>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
                <hr id="hr2" />
                <div className="accordion ">
                  <Accordion>
                    <Accordion.Item eventKey="0" className="b-n">
                      <Accordion.Header>
                        <TbListDetails className="price-gr" />
                        Details
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="tab">
                          <span>Contract Address</span>
                          <div
                            className="contract"
                            onClick={() => {
                              navigator.clipboard
                                .writeText(tokenAddress)
                                .then(() => {
                                  notify("Text copied to clipboard");
                                });
                            }}
                          >
                            <span>
                              {tokenAddress ? slice(tokenAddress) : ""}
                            </span>
                          </div>
                        </div>
                        <div className="tab">
                          <span>Supply</span>
                          <div className="contract">
                            <span>{totalSupple}</span>
                          </div>
                        </div>
                        <div className="tab">
                          <span>Token ID</span>
                          <div
                            className="contract"
                            onClick={() => {
                              navigator.clipboard
                                .writeText(tokenID)
                                .then(() => {
                                  notify("Text copied to clipboard");
                                });
                            }}
                          >
                            <span>{tokenID}</span>
                          </div>
                        </div>
                        <div className="tab">
                          <span>Token Standard</span>
                          <div className="contract">
                            <span>MAAL-{type}</span>
                          </div>
                        </div>
                        <div className="tab">
                          <span>Chain</span>
                          <div className="contract">
                            <span>{Number(nft?.chain) === 7862 ? "MAAL MAINNET" : "MAAL TESTNET V2"}</span>
                          </div>
                        </div>
                        <div className="tab">
                          <span>Last Updated</span>
                          <div className="contract">
                            <span>{Time_ago(lastupdate)}</span>
                          </div>
                        </div>
                        {/* <div className="tab">
                          <span>Creator Earnings</span>
                          <div className="contract">
                            <span>2.5%</span>
                          </div>
                        </div> */}
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </div>
            </div>
          </Grid>
          <Grid xl={7} lg={7} md={12} sm={12} xs={12}>
            <div className="container-fluid ">
              <div className="row ">
                <div className="col-12  m-q-b-d-n">
                  <div className="d-f  j-c-s-b">
                    <div className="">
                      <Link to={`/collection/${collection_name}/${collection}`}>
                        <span className="yellow_clr">{collection_name}</span>
                      </Link>
                    </div>
                    <div className="">
                      <div className="">
                        {" "}
                        {validator ? (
                          <Button
                            variant="primary"
                            className="sell-buttons"
                            id="button-sell-color"
                          >
                            {validatorLockedTill
                              ? `Locked until ${new Date(validatorLockedTill).toLocaleDateString()}`
                              : "Not for Sale"}
                          </Button>
                        ) : (owner === UserWallet && isListed) ||
                        seller == UserWallet ? (
                          <Button
                            variant="primary"
                            // onClick={handleShow4}
                            className="sell-buttons"
                            id="button-sell-color"
                          >
                            Listed for Sale
                          </Button>
                        ) : owner == UserWallet && !isListed ? (
                          <Button
                            variant="primary"
                            onClick={handleShow4}
                            className="sell-buttons"
                            id="button-sell-color"
                          >
                            List for Sale
                          </Button>
                        ) : owner === "1155" &&
                          !isListed &&
                          balance_1155 > 0 ? (
                          <Button
                            variant="primary"
                            onClick={handleShow4}
                            className="sell-buttons"
                            id="button-sell-color"
                          >
                            List for Sale
                          </Button>
                        ) : owner != UserWallet && isListed ? (
                          <Button
                            variant="primary"
                            onClick={handleShow5}
                            className="sell-buttons"
                            id="button-sell-color"
                          >
                            Make offer
                          </Button>
                        ) : (
                          <Button
                            variant="primary"
                            // onClick={handleShow5}
                            className="sell-buttons"
                            id="button-sell-color"
                          >
                            Not for Sale
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 m-q-b-d-n">
                  <div className="ii">
                    <span>{/* <BsFillShareFill /> */}</span>
                    <span>{/* <BsThreeDots className="share" /> */}</span>
                  </div>
                </div>
                <div></div>
                <div>
                  <div className="d-f a-i-c j-c-s-b">
                    <div className="m-q-b-d-n">
                      {type == 721 ? (
                        <div className="">
                          <div className="merge25 m-q-b-d-n m-t-1 m-b-0_5">
                            {name} (#{tokenID})
                          </div>
                          <div className="m-q-b-d-n">
                            <div className="">
                              Owned by{" "}
                              {owner == UserWallet ? "You" : sliceAdd(owner)}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="m-q-b-d-n">
                          <div className="merge25 m-q-b-d-n m-t-2">{name}</div>
                          You own {balance_1155} of this
                        </div>
                      )}
                    </div>
                    {/* {creatoraddress == UserWallet &&
                    totalMinted < totalSupple &&
                    type == 721 ? (
                      <div className="">
                        <button
                          className="para_clr  b-1 b-r-10 p-x-2 p-y-0_5 b-c-t m-t-1  "
                          onClick={handleShow_minting}
                        >
                          {" "}
                          Mint
                        </button>
                      </div>
                    ) : (
                      ""
                    )} */}
                    {!validator && (owner == UserWallet || balance_1155 > 0) ? (
                      <div className="m-q-d-b m-q-m-a">
                        <button
                          className="sell-buttons btn btn-primary"
                          id="button-sell-color"
                          onClick={handleShow8}
                        >
                          Transfer
                        </button>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                {/* <div className="view">
                  <span className="ss">
                    <BsEye className="eye" />
                    <span>5 views</span>
                  </span>{" "}
                  <AiOutlineApartment className="eye" />
                  <span>Art</span>
                </div> */}
                {false ? (
                  <>
                    {isListed ? (
                      <div className="m-b-1">
                        <span className="num">{listedprice} MAAL</span>
                        <span className="num-sub">( ${listedprice} )</span>
                      
                      </div>
                    ) : (
                      ""
                    )}
                  </>
                ) : (
                  <div>
                    <div className="best-con">
                      {/* <span className="off">Best Offer</span> */}
                    
                      {isListed ? (
                        <div className="m-b-1">
                          <div className="m-b-1">Current Price</div>
                          <span className="num f-s-2 f-w-600 m-r-1">
                            {listedprice} {listingTokenSymbol}
                          </span>
                          <span>
                            ${""}
                            {listingTokenSymbol === "XAUS"
                              ? Number(listedprice * receiveXaus).toFixed(2)
                              : listingTokenSymbol === "MAAL" ? Number(listedprice  * (maalprice)).toFixed(5) : 0 }
                          </span>
                         
                        </div>
                      ) : (
                        ""
                      )}

                      {!validator && seller != UserWallet && isListed ? (
                        <button className="bu m-r-1 h-3" onClick={handleShow6}>
                          Buy now
                        </button>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                )}
                <div className="accordion my-4">
                  <Accordion defaultActiveKey="0">
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        <SlGraph className="price-gr" />
                        Price History
                      </Accordion.Header>
                      <Accordion.Body className="p-y-3 t-a-c">
                        No item yet
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
                <div className="accordion my-4">
                  <Accordion defaultActiveKey="0">
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        <BsFillTagFill className="price-gr" />
                        Listings
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="listing">
                          <img src={Svgimg} alt="" />
                        </div>
                        <div className="list-no">
                          <div>No listings yet</div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
                <div className="accordion my-4">
                  <Accordion defaultActiveKey="0">
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        <TfiMenuAlt className="price-gr" />
                        Offers
                      </Accordion.Header>
                      <Accordion.Body>
                        <Grid container>
                          <Grid item lg={3} md={3} sm={3} xs={3}>
                            <div>
                              <span className="span-pp">Price</span>
                            </div>
                          </Grid>

                          <Grid item lg={3} md={3} sm={3} xs={3}>
                            <div>
                              <span className="span-pp">From</span>
                            </div>
                          </Grid>

                          <Grid item lg={3} md={3} sm={3} xs={3}>
                            <div>
                              <span className="span-pp">Expire Time</span>
                            </div>
                          </Grid>

                          <Grid item lg={3} md={3} sm={3} xs={3}>
                            <div>
                              <span className="span-pp">Action</span>
                            </div>
                          </Grid>
                        </Grid>
                      </Accordion.Body>
                      <Accordion.Body>
                        {alloffers === undefined ? (
                          "Not Found"
                        ) : alloffers.length > 0 ? (
                          alloffers.map((res) => {
                            return (
                              <Grid container>
                                <Grid item lg={3} md={3} sm={3} xs={3}>
                                  <div>
                                    <span>
                                      {res.pricePerNFT / 10 ** 18}{" "}
                                      {res.symbol}
                                    </span>
                                  </div>
                                </Grid>
                                <Grid item lg={3} md={3} sm={3} xs={3}>
                                  <div>
                                    <span>{sliceAdd(res.offerCreator)}</span>
                                  </div>
                                </Grid>
                                <Grid item lg={3} md={3} sm={3} xs={3}>
                                  <div>
                                    <span>
                                      {Time_data(
                                        Number(res.offerExpireTime) * 1000
                                      )}
                                    </span>
                                  </div>
                                </Grid>
                                {!validator &&
                                (seller == UserWallet ||
                                  owner == UserWallet ||
                                  Number(balance_1155) > 0) ? (
                                  <Grid item lg={3} md={3} sm={3} xs={3}>
                                    <div>
                                      <button
                                        onClick={() =>
                                          accept_offer(
                                            convertToLowercase(
                                              res.offerCreator
                                            ),
                                            res.pricePerNFT,
                                            res.offerId,
                                            res.quantity
                                          )
                                        }
                                        className="b-c-t b-1 m-b-1 p-x-2 p-y-0_5 b-r-10"
                                      >
                                        Accept
                                      </button>
                                    </div>
                                  </Grid>
                                ) : convertToLowercase(res.offerCreator) ===
                                  UserWallet ? (
                                  <Grid item lg={3} md={3} sm={3} xs={3}>
                                    <div>
                                      <button
                                        onClick={() => {
                                          handleShow7();
                                          setOfferID(res.offerId);
                                        }}
                                        className="b-c-t b-1 m-b-1"
                                      >
                                        Update
                                      </button>
                                    </div>
                                  </Grid>
                                ) : (
                                  ""
                                )}
                              </Grid>
                            );
                          })
                        ) : (
                          <div className="p-y-3 t-a-c">No data to show...</div>
                        )}
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
        <div className="container-fluid my-5">
          <div>
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <RiArrowUpDownFill className="price-gr" />
                  Item Activity
                </Accordion.Header>
                <Accordion.Body>
                  <div>
                    {" "}
                    <InputGroup className="mb-3 filterinput ">
                      <Form.Control
                        aria-label="Text input with dropdown button"
                        placeholder="Filter"
                      />

                      <DropdownButton
                        variant="outline-secondary"
                        title={<IoIosArrowDown />}
                        id="input-group-dropdown-2"
                        align="end"
                      >
                        <Dropdown.Item href="#">Sales</Dropdown.Item>{" "}
                        <Dropdown.Divider />
                        <Dropdown.Item href="#">Listings</Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item href="#">Offers</Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item href="#">Transfers</Dropdown.Item>
                      </DropdownButton>
                    </InputGroup>
                  </div>
                  <Accordion.Body>
                    <Grid container>
                      <Grid item xs className="t-a-c">
                        <div>
                          <span className="span-pp">Event</span>
                        </div>
                      </Grid>
                      <Grid item xs className="t-a-c">
                        <div>
                          <span className="span-pp">Price</span>
                        </div>
                      </Grid>

                      <Grid item xs className="t-a-c">
                        <div>
                          <span className="span-pp">From</span>
                        </div>
                      </Grid>
                      <Grid item xs className="t-a-c">
                        <div>
                          <span className="span-pp">To</span>
                        </div>
                      </Grid>
                      <Grid item xs className="t-a-c">
                        <div>
                          <span className="span-pp">Date</span>
                        </div>
                      </Grid>
                    </Grid>
                  </Accordion.Body>
                  <Accordion.Body>
                    {nfttransaction ? (
                      nfttransaction.length === 0 ? (
                        <div className="p-y-3 t-a-c">No data to show...</div>
                      ) : (
                        nfttransaction.map((res) => {
                          return (
                            <Grid container>
                              <Grid item xs className="t-a-c">
                                <div>
                                  <span className="price-amu">
                                    <BiTransfer className="trans" />
                                    {res.event}
                                  </span>
                                </div>
                              </Grid>
                              <Grid item xs className="t-a-c">
                                <div>
                                  <span>
                                    {res.value}{" "}
                                    {res.symbol ? res.symbol : "unknown"}
                                  </span>
                                </div>
                              </Grid>
                              <Grid item xs className="t-a-c">
                                <div>
                                  <span className="from-da">
                                    {sliceAddresss(res.from)}
                                  </span>
                                </div>
                              </Grid>
                              <Grid item xs className="t-a-c">
                                <div>
                                  <span className="from-da">
                                    {sliceAddresss(res.to)}
                                  </span>
                                </div>
                              </Grid>
                              <Grid item xs className="t-a-c">
                                <div>
                                  <span className="from-te">
                                    {Time_ago(res.time)}{" "}
                                    <span className="grshare"></span>
                                  </span>
                                </div>
                              </Grid>
                            </Grid>
                          );
                        })
                      )
                    ) : (
                      ""
                    )}
                  </Accordion.Body>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
          <div className="my-5">
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <BsFillCollectionFill className="price-gr" />
                  More From This Collection
                </Accordion.Header>
                <Accordion.Body>
                  <div className="container-fluid">
                    <div className="row mb-5">
                      {nftofsamecollection === undefined ? (
                        <div className="p-y-3 t-a-c">Not data to show...</div>
                      ) : nftofsamecollection.length > 0 ? (
                        nftofsamecollection.map((res) => {
                          return (
                            <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                              <Card className="profile-card">
                                <Card.Img variant="top" src={res.imageURL} />
                                <Card.Body>
                                  <div className="d-f j-c-s-b a-i-c">
                                    <div className="">
                                      <Card.Title className="card-head">
                                        {res.name}
                                      </Card.Title>
                                      {res.pricing == 0 ? (
                                        "Not listed"
                                      ) : (
                                        <Card.Text>
                                          {res.pricing / 10 ** 18}
                                        </Card.Text>
                                      )}
                                      <br />
                                      <span className="last-da">
                                        Last Sale: 0.088 ETH
                                      </span>
                                    </div>
                                  </div>
                                </Card.Body>
                                <div className="add-cart-section ">
                                  <Link to={`/assets/${res._id}`}>
                                    <div className="add-cart-section ">
                                      <span className="add-sec">View</span>
                                    </div>
                                  </Link>
                                  <span className="add-sec buy">
                                    <AiFillThunderbolt className="buy-thunder" />
                                    Buy now
                                  </span>
                                </div>
                              </Card>
                            </div>
                          );
                        })
                      ) : (
                        <div className="p-y-3 t-a-c">Not found</div>
                      )}
                    </div>
                  </div>
                </Accordion.Body>

                {/* <Accordion.Body>
                  <div className="view-btn1">
                    <button className="collection-btn">View collection</button>
                  </div>
                </Accordion.Body> */}
              </Accordion.Item>
            </Accordion>
          </div>
        </div>

        {/* ------------Sell------------- */}

        <Modal
          show={show4}
          // show={true}
          onHide={handleClose4}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header className="w-100">
            <div className="d-f j-c-s-b a-i-c w-100">
              <div className="">
                <Modal.Title>Sell NFTs</Modal.Title>
              </div>
              <div className="">
                <RxCross1 className="c-p" onClick={handleClose4} />
              </div>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="pa-3 t-a-c">
              <div className="input-field m-y-2 w-100">
                <div className="d-f a-i-c b-1 b-r-10">
                  <div className="w-100  d-f a-i-c j-c-s-b">
                    <input
                      onChange={(e) => handlePrice(e.target.value)}
                      type="text"
                      className=" w-100 pa-0_5 b-n"
                      id="input-submit-btn"
                      placeholder="price per NFT"
                    />
                    <select
                      onChange={(e) => setTokenForSale(e.target.value)}
                      className="b-n o-n p-x-0_5"
                    >
                      <option value="Select" selected>
                        Select Token
                      </option>
                      {MAINNETTOKENS.map((res) => {
                        return <option value={res.address}>{res.name}</option>;
                      })}
                    </select>
                  </div>

                  {/* <div className=" w-s-n-w pa-0_5">MAAL</div> */}
                </div>
                <div className="m-y-2">
                  {type === 721 ? (
                    ""
                  ) : (
                    <input
                      type="number"
                      value={quantityToSale}
                      onChange={(e) => {
                        if (Number(e.target.value) > Number(balance_1155)) {
                          return;
                        }
                        setQuantityToSale(e.target.value);
                      }}
                      placeholder="quantity"
                      className=" w-100 pa-0_5 b-1 b-r-10"
                    />
                  )}
                  {/* {console.log(balance_1155, quantityToSale)} */}
                </div>
                <div className="m-y-2">
                  <div className="m-b-0_5 t-a-l">Select Date</div>
                  <DatePicker
                    showTime
                    onChange={(value) => {
                      // Check if a valid date and set the expireTime state
                      if (value) {
                        setExpireTime(Math.floor(value.toDate()));
                      } else {
                        setExpireTime(null); // Handle when the value is null (e.g., when clearing the date)
                      }
                    }}
                    className="w-100"
                  />
                </div>
              </div>
              <span onClick={handleClose4}>
                <button
                  className="sell-btn  b-1 para_clr"
                  onClick={() => sellNFT()}
                >
                  Submit
                </button>
              </span>
            </div>
          </Modal.Body>
        </Modal>

        {/* --------------Make Offer----------------- */}

        <Modal
          show={show5}
          onHide={handleClose5}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header className="w-100">
            <div className="d-f j-c-s-b a-i-c w-100">
              <div className="">
                <Modal.Title>
                  <div className="">Make Offer</div>
                </Modal.Title>
              </div>
              <div className="">
                <RxCross1 className="c-p" onClick={handleClose5} />
              </div>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="pa-3 t-a-c">
              <div className="input-field m-y-1 w-100">
                <div className="d-f a-i-c m-y-2 b-1 b-r-10">
                  <div className="w-100  ">
                    <input
                      placeholder="amount per nft"
                      onChange={(e) => setOfferamount(e.target.value)}
                      type="text"
                      className=" w-100 pa-0_5 b-n"
                      id="input-submit-btn"
                    />
                  </div>
                  <div className=" w-s-n-w pa-0_5">
                    {Number(listingTokenBalance).toFixed(3)}{" "}
                    {listingTokenSymbol}
                  </div>
                </div>

                <div className="m-y-2">
                  <input
                    type="text"
                    placeholder={`Max quantity to puchase is ${quantityonsale}`}
                    onChange={(e) => {
                      if (Number(e.target.value) > quantityonsale) {
                        warning(`Max purchase is ${quantityonsale}`);
                        return;
                      }
                      setQuantityToPurchase(e.target.value);
                    }}
                    className="w-100 b-1 b-r-10 pa-0_5"
                  />
                </div>
                <div className="m-y-2">
                  <div className="m-b-0_5 t-a-l">Select Date</div>
                  <DatePicker
                    showTime
                    onChange={(value) => {
                      // Check if a valid date and set the expireTime state
                      if (value) {
                        setOfferExpire(Math.floor(value.toDate()));
                      } else {
                        setOfferExpire(null); // Handle when the value is null (e.g., when clearing the date)
                      }
                    }}
                    className="w-100"
                  />
                </div>
              </div>

              <span onClick={handleClose5}>
                <button
                  className="primary-btn m-b-2"
                  onClick={() => make_Offerr()}
                >
                  Submit
                </button>
              </span>
            </div>
          </Modal.Body>
        </Modal>

        {/* --------------Minting----------------- */}

        <Modal
          show={show_minting}
          onHide={handleClose_minting}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header className="w-100">
            <div className="d-f j-c-s-b a-i-c w-100">
              <div className="">
                <Modal.Title>
                  <div className="">Minting</div>
                </Modal.Title>
              </div>
              <div className="">
                <RxCross1 className="c-p" onClick={handleClose_minting} />
              </div>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="pa-3 t-a-c">
              <div className="input-field m-y-1 w-100">
                <div className="m-b-2">
                  <input
                    type="text"
                    onChange={(e) =>
                      setReceiverAddresss(convertToLowercase(e.target.value))
                    }
                    placeholder="enter receiver address"
                    className="w-100 b-1 b-r-10 pa-0_5"
                  />
                </div>
              </div>

              <span onClick={handleClose5}>
                {/* <button
                  className="primary-btn m-b-2"
                  onClick={() => mintAgain(nft)}
                >
                  Mint
                </button> */}
              </span>
            </div>
          </Modal.Body>
        </Modal>

        {/* ---------------Buy nft------------- */}
        <Modal
          show={show6}
          onHide={handleClose6}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header className="w-100">
            <div className="d-f j-c-s-b a-i-c w-100">
              <div className="">
                <Modal.Title>
                  <div className="">Buy NFT</div>
                </Modal.Title>
              </div>
              <div className="">
                <RxCross1 className="c-p" onClick={handleClose6} />
              </div>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="pa-3 t-a-c">
              <div className="input-field m-y-1 w-100">
                <div className="d-f a-i-c m-y-2 b-1 b-r-10">
                  <div className="w-100  ">
                    <input
                      placeholder={`quantity on sale are ${quantityonsale}`}
                      onChange={(e) =>
                        setQuantityToPurchaseDirect(e.target.value)
                      }
                      type="text"
                      className=" w-100 pa-0_5 b-n"
                      id="input-submit-btn"
                    />
                  </div>
                </div>
              </div>

              <span onClick={handleClose5}>
                <button className="primary-btn m-b-2" onClick={() => buy_nft()}>
                  Submit
                </button>
              </span>
            </div>
          </Modal.Body>
        </Modal>

        {/* ---------------Update Offer------------- */}
        <Modal
          show={show7}
          onHide={handleShow7}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header className="w-100">
            <div className="d-f j-c-s-b a-i-c w-100">
              <div className="">
                <Modal.Title>
                  <div className="">Update Offer</div>
                </Modal.Title>
              </div>
              <div className="">
                <RxCross1 className="c-p" onClick={handleShow7} />
              </div>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="pa-3 t-a-c">
              <div className="input-field m-y-1 w-100">
                <div className="d-f a-i-c m-y-2 b-1 b-r-10">
                  <div className="w-100">
                    <input
                      placeholder="amount per nft"
                      onChange={(e) => setNewPrice(e.target.value)}
                      type="text"
                      className=" w-100 pa-0_5 b-n"
                      id="input-submit-btn"
                    />
                  </div>
                  <div className=" w-s-n-w pa-0_5">
                    {Number(listingTokenBalance).toFixed(3)}{" "}
                    {listingTokenSymbol}
                  </div>
                </div>

                <div className="m-y-2">
                  <div className="m-b-0_5 t-a-l">Select Date</div>

                  <DatePicker
                    showTime
                    onChange={(value) => {
                      // Check if a valid date and set the expireTime state
                      if (value) {
                        setNewTime(Math.floor(value.toDate()));
                      } else {
                        setNewTime(null); // Handle when the value is null (e.g., when clearing the date)
                      }
                    }}
                    className="w-100"
                  />
                </div>
              </div>

              <span onClick={handleShow7}>
                <button
                  className="primary-btn m-b-2"
                  onClick={() => updateOffer(newprice, newTime)}
                >
                  Update Offer
                </button>
              </span>
              <br />
              <span onClick={handleShow7}>
                <button
                  className="primary-btn m-b-2"
                  onClick={() => CancalOffer(offerID)}
                >
                  Cancel Offer
                </button>
              </span>
            </div>
          </Modal.Body>
        </Modal>

        {/* ---------------transfer------------- */}
        <Modal
          show={show8}
          onHide={handleClose8}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header className="w-100">
            <div className="d-f j-c-s-b a-i-c w-100">
              <div className="">
                <Modal.Title>
                  <div className="">Transfer</div>
                </Modal.Title>
              </div>
              <div className="">
                <RxCross1 className="c-p" onClick={handleClose8} />
              </div>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="pa-3 t-a-c">
              <div className="input-field m-y-1 w-100">
                <div className="d-f a-i-c m-y-2 b-1 b-r-10">
                  <div className="w-100  ">
                    <input
                      type="text"
                      placeholder={`recevier's address`}
                      onChange={(e) =>
                        setTransferaddress(convertToLowercase(e.target.value))
                      }
                      className="w-100 b-1 b-r-10 pa-0_5"
                    />
                    <br />
                    {type == 1155 ? (
                      <input
                        type="text"
                        placeholder={`amount to transfer`}
                        onChange={(e) => setTransferAmount(e.target.value)}
                        className="w-100 b-1 b-r-10 pa-0_5"
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>

              <button
                className="primary-btn m-b-2"
                onClick={() => transferNFT()}
              >
                Submit
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </Box>

      <Footer />
      <Toaster />
      {/* {open ? <Loader percent={percent} /> : ""} */}

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
